export default __webpack_public_path__ + "static/media/renBTC.25269aab.svg";